import React from 'react';
import './LegalPage.css';

const Disclaimer = () => {
  return (
    <div className="legal-page">
      <div className="legal-container">

        <div className="legal-header">
          <h1>Disclaimer</h1>
        </div>

        <div className="legal-notice legal-notice--warning">
          ⚠️ Important: Please read this disclaimer carefully before using SwingSetupAI.
          By accessing or using the platform, you acknowledge that you have read, understood,
          and agreed to this disclaimer.
        </div>

        <div className="legal-section">
          <p>
            SwingSetupAI and its operators are NOT registered with the Securities and Exchange
            Board of India (SEBI) as Investment Advisers, Research Analysts, Stock Brokers,
            Portfolio Managers, or in any other SEBI-regulated capacity.
          </p>
        </div>

        <div className="legal-section">
          <p>
            All content, including screeners, charts, data, patterns, and analysis, is provided
            strictly for educational and informational purposes only. Nothing on this platform
            constitutes investment advice, financial advisory services, a recommendation to buy,
            sell, or hold any security, or a research report.
          </p>
        </div>

        <div className="legal-section">
          <p>
            SwingSetupAI is a technical pattern screening tool that identifies historical chart
            patterns. These outputs are algorithmic in nature and do not constitute trading
            signals or recommendations. Technical analysis has inherent limitations and does
            not guarantee future results.
          </p>
        </div>

        <div className="legal-section">
          <p>
            Your use of this platform does not create any advisory, fiduciary, or client
            relationship between you and SwingSetupAI.
          </p>
        </div>

        <div className="legal-section">
          <p>
            Data may be sourced from third-party providers and processed through automated
            systems. We do not guarantee the accuracy, completeness, or timeliness of any
            data or outputs, and all decisions made based on such information are at your
            own risk.
          </p>
        </div>

        <div className="legal-section">
          <p>
            Before making any investment decision, you are strongly advised to consult a
            SEBI-registered Investment Adviser or Research Analyst.
          </p>
        </div>

        <div className="legal-section">
          <p>
            We reserve the right to update or modify this disclaimer at any time without
            prior notice.
          </p>
        </div>

      </div>
    </div>
  );
};

export default Disclaimer;
